









































































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import { ReduceTicketReq } from "@/pbjs/external/ticket/ticket_pb";
import { ticketClient } from "@/api";
import { localGet, timeFormat } from "@/utils";
import { handleResponse, errorMsg, setCommon } from "@/utils/request";

@Component({
  name: "newOrder",
})
export default class CombinationProperty extends Vue {
  @Prop() ticketData!: any;
  @Prop() subOrderid!: any;
  @Prop() multi_loan_switch!: any;

  @Provide() private principalData: any = [];
  @Provide() private system: any = localStorage.getItem("systemInfo");
  @Provide() private leftamount: any = null;
  @Provide() private isReduceTicketDone: boolean = false;
  @Provide() private isUseAmountRemained: boolean = false;
  @Provide() private amountremained: any = "";

  @Provide() private principalForm: any = {
    principal: null,
    reason: "",
  };
  @Provide() private showTimesTips: any = {
    showlefttotaltips: null,
    lefttotalgroup: "",
    lefttotalstaff: "",
    showleftapplyamounttips: "",
    leftapplyamount: "",
  }; //减免次数展示

  private created() {
    this.reduceTicket();
  }

  private resetForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.resetFields();
  }

  private closeDialog() {
    this.$emit("showDiffTypeDialog", 0);
  }

  private principalChange(e: any) {
    this.principalForm.principal = e;
  }

  private reduceTicketFuc(data: any) {
    this.isUseAmountRemained = data.amountremained == 0 ? false : true;
    // amountremained<0 means amountremained is 0 actually, just distinguish with not pass
    this.amountremained = data.amountremained < 0 ? 0 : data.amountremained;
    this.leftamount = data.amount - data.amountpayed - data.amountreduced;
    this.principalData = [
      {
        label1: this.$t("ticket.DueDate"),
        value1: timeFormat(data.shouldrepaydate),
        label2: this.$t("ticket.ActualPaymentDate"),
        value2: timeFormat(data.actuallyrepaydate),
        label3: this.$t("ticket.RemissionDay"),
        value3: timeFormat(data.latestreducedate),
      },
      {
        label1: this.$t("ticket.Principal"),
        value1: data.amount,
        label2: this.$t("ticket.ActualRepaymentPrincipal"),
        value2: data.amountpayed,
        label3: this.$t("ticket.ReferralDirector"),
        value3: data.amountreduced,
        label4: this.$t("ticket.TheRemainingPrincipalCanBeReduced"),
        value4: this.isUseAmountRemained
          ? this.amountremained
          : this.leftamount,
      },
    ];
    if (data.showleftpercenttips) {
      this.principalData.push({
        label1: this.$t("ticketFhb.IndividualDeductibleAmount"),
        value1: data.leftamounttotalstaff,
        label2: this.$t("ticketFhb.GroupDeductibleAmount"),
        value2: data.leftamounttotalgroup,
      });
    }
    this.showTimesTips = {
      showlefttotaltips: data.showlefttotaltips,
      lefttotalgroup: data.lefttotalgroup,
      lefttotalstaff: data.lefttotalstaff,
      showleftapplyamounttips: data.showleftapplyamounttips,
      leftapplyamount: data.leftapplyamount,
    };
  }
  private reduceTicket() {
    let request: any = new ReduceTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(this.ticketData.itemid);
    request.setTicketid(this.ticketData.id);
    request.setOrderid(
      this.multi_loan_switch ? this.subOrderid + "" : this.ticketData.orderid
    );
    ticketClient.reduceTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();

        let _fuc = this.reduceTicketFuc(data);
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private doReduceTicketFuc() {
    this.resetForm("principalForm");
    this.closeDialog();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  // 减免本金  拆分后接口
  private async doReducePrincipal() {
    if (this.isUseAmountRemained) {
      if (this.amountremained >= this.principalForm.principal) {
        this.isReduceTicketDone = true;
        let _arg: any = {
          TicketId: this.ticketData.id,
          ItemId: this.ticketData.itemid,
          ReductionAmount: Number(this.principalForm.principal),
          Reason: this.principalForm.reason,
          orderid: this.multi_loan_switch
            ? this.subOrderid
            : this.ticketData.orderid,
        };
        const {
          getReducePrincipalReq,
          getReducePrincipalRequest,
        }: any = await import("@/request/reducePrincipalAndOther");
        let res = await getReducePrincipalRequest.handleHttp(
          getReducePrincipalReq(_arg),
          this
        );
        if (res && res.right) {
          this.doReduceTicketFuc();
        } else {
          this.isReduceTicketDone = false;
        }
      } else {
        let _text = this.$tc("OrderStatus.beyondCompareSubmitFailed");
        this.$message({
          type: "error",
          message: _text,
        });
      }
    } else {
      if (this.leftamount >= this.principalForm.principal) {
        this.isReduceTicketDone = true;
        let _arg: any = {
          TicketId: this.ticketData.id,
          ItemId: this.ticketData.itemid,
          ReductionAmount: Number(this.principalForm.principal),
          Reason: this.principalForm.reason,
          orderid: this.multi_loan_switch
            ? this.subOrderid
            : this.ticketData.orderid,
        };
        const {
          getReducePrincipalReq,
          getReducePrincipalRequest,
        }: any = await import("@/request/reducePrincipalAndOther");
        let res = await getReducePrincipalRequest.handleHttp(
          getReducePrincipalReq(_arg),
          this
        );
        if (res && res.right) {
          this.doReduceTicketFuc();
        } else {
          this.isReduceTicketDone = false;
        }
      } else {
        let _text = this.$tc("OrderStatus.beyondCompareSubmitFailed");
        this.$message({
          type: "error",
          message: _text,
        });
      }
    }
  }
}
